<template lang="html">
  <div>
    <div class="label node-move">
      <span>Attributes</span>
      <button type="button" class="btn-flat btn-icon" @click="addAttribute()"><i class="icon-add"></i></button>
    </div>
    <div v-for="(attribute, index) in node.attributes" :key="index" class="node-choice">
      <input type="text" v-model="attribute.key" placeholder="key" class="form-input" />
      <input type="text" v-model="attribute.value" placeholder="value" class="form-input" />
      <button type="button" class="btn-flat btn-icon" @click="removeAttribute(index)"><i class="icon-delete"></i></button>
    </div>
  </div>
</template>

<script>
export default {
	props: ['node'],
	// emits: ['update:modelValue'],
	methods: {
    addAttribute() {
      this.node.attributes.push({
        key: '',
        value: ''
      });
    },
    removeAttribute(index) {
      this.node.attributes.splice(index, 1);
    }
	}
}
</script>

<style lang="css" scoped>
.node-choice {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.node-choice input {
  font-family: monospace;
  border: none;
}
.node-choice button {
  margin: 0 2px;
  padding: 3px;
}
</style>
